import { render, staticRenderFns } from "./Badge5.vue?vue&type=template&id=83d43886&scoped=true"
import script from "./Badge5.vue?vue&type=script&lang=js"
export * from "./Badge5.vue?vue&type=script&lang=js"
import style0 from "./Badge5.vue?vue&type=style&index=0&id=83d43886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d43886",
  null
  
)

export default component.exports